module.exports = __webpack_public_path__ + "img/91.08ee5be3.jpg";